<app-sidebar>
  <div class="street-info-page">
    <div class="page-nav">
      <button mat-stroked-button type="button" (click)="backToMap()">
        <mat-icon>arrow_back</mat-icon>
        Back to street map
      </button>
    </div>

    <div class="page-header">
      <h1>{{ streetName }}</h1>
      <p>{{ suburbName }}</p>
    </div>

    <mat-card class="table-card">
      <mat-card-content>
        <div class="table-toolbar">
          <mat-form-field appearance="outline">
            <mat-label>Filter houses</mat-label>
            <input matInput (input)="applyFilter($any($event.target).value)" />
          </mat-form-field>
        </div>

        <div *ngIf="isLoading" class="loading-state">
          <mat-spinner diameter="40"></mat-spinner>
          <p>Loading street info...</p>
        </div>

        <table mat-table [dataSource]="dataSource" matSort *ngIf="!isLoading">
          <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Owner name</th>
            <td mat-cell *matCellDef="let row">{{ row.fullName || 'N/A' }}</td>
          </ng-container>

          <ng-container matColumnDef="houseNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>House number</th>
            <td mat-cell *matCellDef="let row">{{ row.houseNumber || 'N/A' }}</td>
          </ng-container>

          <ng-container matColumnDef="erfNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Erf number</th>
            <td mat-cell *matCellDef="let row">{{ row.erfNumber || 'N/A' }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let row">
              <button
                mat-icon-button
                color="primary"
                matTooltip="View profile"
                (click)="openSubjectProfile(row)">
                <mat-icon>visibility</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="25"></mat-paginator>
      </mat-card-content>
    </mat-card>
  </div>
</app-sidebar>
